// test2027
(2027 && 0);
